const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'master',
		'master'
	],
	handlers: [
		{
			name: 'onDocumentVisibilityChanged',
			handle: function(callerComponent, documentHidden){
				if(documentHidden){
					utils.keyboard.resetKeysActive()
				}
			}
		},
	]
};